module.exports = __webpack_public_path__ + "img/gt-r-gt-r-nismo-difference.08c0923e.jpg";